import React, { PureComponent } from 'react';
import { object, func, bool } from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import Header from '../Header';
import { colors } from '../../../constants/colors';
import { fontFamily, fontSize } from '../../../constants/text';
import AutocompleteResults from '../AutocompleteResults';
import { REQUEST_UNIVERSAL_SEARCH } from '../../../sagas/universalSearch';

const Root = styled.div`
  background-color: ${colors.greyDim};
  min-height: 100%;
`;

const ContentContainer = styled.div`
  padding: 24px 16px;
  text-align: center;
`;

const ErrorReason = styled.div`
  margin: 0 auto;
  font-size: ${fontSize.default};
  font-family: ${fontFamily.book};
  line-height: 24px;
  color: ${colors.squid};

  & em {
    color: ${colors.crunchBerry};
    font-style: normal;
  }

  & b {
    font-family: ${fontFamily.bold};
    font-weight: normal;
  }
`;

class UserChoiceContent extends PureComponent {
  static propTypes = {
    universalSearch: object,
    onClickBack: func,
    requestSearch: func,
    fromSrp: bool,
    searchPreferences: object,
    position: object,
  };

  getSuggestionCopy = () => {
    const { universalSearch } = this.props;

    return universalSearch.results.length
      ? 'Try the suggestions below'
      : 'Try the options below or refine your search';
  };

  getLocationLabel = () => {
    const { searchPreferences, position } = this.props;

    if (searchPreferences && searchPreferences.location) return searchPreferences.location.label;
    if (position && position.result) return position.result.label;
    return '';
  };

  handleDocSelect = selectedDoc => {
    const { requestSearch } = this.props;

    requestSearch(selectedDoc);
  };

  render() {
    const { universalSearch, onClickBack } = this.props;
    const remappedSuggestions = universalSearch.results.map(result => ({
      ...result,
      onClick: () => this.handleDocSelect(result.fullDoc),
    }));

    return (
      <Root>
        <Header
          hideSearch
          onCancel={onClickBack}
          onConfirm={onClickBack}
          title="Find Care"
          cancelCopy=""
          confirmCopy="Cancel"
        />
        <ContentContainer>
          <ErrorReason>
            We couldn't find an exact match for
            <br />"<em>{universalSearch.query}</em>" in
            <b> {this.getLocationLabel()}</b>
          </ErrorReason>
          <br />
          <ErrorReason>{this.getSuggestionCopy()}</ErrorReason>
        </ContentContainer>
        <AutocompleteResults results={remappedSuggestions} />
      </Root>
    );
  }
}

export default connect(
  ({ universalSearch, searchPreferences, position }) => ({
    universalSearch,
    position,
    searchPreferences,
  }),
  (dispatch, ownProps) => ({
    requestSearch: fullDoc =>
      dispatch({
        type: REQUEST_UNIVERSAL_SEARCH,
        fullDoc,
        fromSrp: ownProps.fromSrp,
      }),
  })
)(UserChoiceContent);
